import styled from "@emotion/styled";
import { ExportExcelHandle } from "./ExportExcel";
import MainToolbar from "components/MainToolbar";
import { Flex, FlexRight, HorizontalSpacer } from "components/styled";
import React from "react";
import { usePaymentPageStore } from "store/PaymentPageStore";
import PaymentsMenubar from "./PaymentsMenubar";
import { ExportExcelButton } from "./navigationbuttons/ExportExcelButton";
import { RefreshButton } from "./navigationbuttons/RefreshButton";
import { Search } from "./navigationbuttons/Search";

import CompaniesMenu from "components/CompaniesMenu";
import { helpAnchor } from "help/anchor";

import DeclarePaymentsButton from "./DeclarePaymentsButton";
import { ExcludeDeclaredPaymentsButton } from "./ExcludeDeclaredPaymentsButton";
export const NavigationBar = styled.div`
  height: 44px;
  background: ${(p) => p.theme.palette.white};
  display: flex;
  align-items: center;
  padding: 0 10px;
  border-bottom: 1px solid ${(p) => p.theme.palette.neutralLight};
  position: sticky;
  top: 0;
  z-index: 2;
`;

type Props = {
  refExcelExport: ExportExcelHandle | undefined;
};

const PaymentPageNavigationFirstLine = ({ refExcelExport }: Props) => {
  const [{ searchTerm }, { setPaymentStoreValue }] = usePaymentPageStore();

  return (
    <NavigationBar style={{ zIndex: 334 }}>
      <MainToolbar
        pageName={"paymentPage"}
        dataHelp={helpAnchor("payments-page-switcher")}
      />
      <RefreshButton />
      <Search
        dataHelp={helpAnchor("payments-search")}
        placeholder="Search"
        value={searchTerm}
        onChange={(value) => setPaymentStoreValue("searchTerm", value)}
      />
      <PaymentsMenubar />
      <ExportExcelButton refExcelExport={refExcelExport} />

      <HorizontalSpacer width={10} />

      <DeclarePaymentsButton />
      <ExcludeDeclaredPaymentsButton />
      <FlexRight>
        <Flex>
          <CompaniesMenu dataHelp={helpAnchor("payments-companies")} />
        </Flex>
      </FlexRight>
    </NavigationBar>
  );
};

export default PaymentPageNavigationFirstLine;
